import component from './icon.vue'

export default component
